/**
 * Messages that are built in code with a value inside, e.g. `Select ${type}`.
 * The finished text can't be looked up in the language files, so each one is
 * described here as an English template and its Spanish template, using
 * {0}, {1}... for the values. The values themselves are translated too when
 * they have a translation (for example "Active" -> "Activo").
 */
const ES_TEMPLATES: [string, string][] = [
  ['Switched to Group "{0}"', 'Cambió al grupo "{0}"'],
  ['Switched to {0}', 'Cambió a {0}'],
  ['An email has been sent to {0} with instructions to reset your password.', 'Se envió un correo electrónico a {0} con instrucciones para restablecer su contraseña.'],
  ['Container {0} attached to {1}', 'Contenedor {0} adjuntado a {1}'],
  ['AWB {0} created successfully.', 'AWB {0} creado correctamente.'],
  ['AWB {0} is now {1}', 'El AWB {0} ahora está {1}'],
  ['Seal {0} created successfully.', 'Sello {0} creado correctamente.'],
  ['Seal {0} is now {1}', 'El sello {0} ahora está {1}'],
  ['Coupon "{0}" applied: ${1} discount!', '¡Cupón "{0}" aplicado: descuento de ${1}!'],
  ['Selected file: {0}', 'Archivo seleccionado: {0}'],
  ['Uploaded: {0}', 'Subido: {0}'],
  ['Receipt {0} approved & verified!', '¡Comprobante {0} aprobado y verificado!'],
  ['Receipt {0} marked as rejected.', 'Comprobante {0} marcado como rechazado.'],
  ['Coupon {0} has been voided.', 'El cupón {0} fue anulado.'],
  ['Downloading invoice {0} as PDF...', 'Descargando la factura {0} como PDF...'],
  ['Sub-service "{0}" added to list.', 'Subservicio "{0}" agregado a la lista.'],
  ['Sub-service "{0}" updated!', '¡Subservicio "{0}" actualizado!'],
  ['Select {0:w}', 'Seleccionar {0}'],
  ['Are you sure you want to select "{0}"?', '¿Está seguro de que desea seleccionar "{0}"?'],
  ['Confirm Entry Number: {0}', 'Confirmar número de entrada: {0}'],
  ['Update Record: {0}', 'Actualizar registro: {0}'],
  ['Payment of ${0} ({1}) recorded for {2:w} entry.', 'Pago de ${0} ({1}) registrado para {2} entrada.'],
  ['Payment of ${0} ({1}) recorded for {2:w} entries.', 'Pago de ${0} ({1}) registrado para {2} entradas.'],
  ['Reason: {0}. The customer will be asked to upload a new receipt.', 'Motivo: {0}. Se le pedirá al cliente que suba un nuevo comprobante.'],
  ['The {0} discount will be removed from entry {1}.', 'El descuento {0} se quitará de la entrada {1}.'],
  ['{0} 1 attempt left before login is locked for 5 minutes.', '{0} Le queda 1 intento antes de que el inicio de sesión se bloquee por 5 minutos.'],
  ['{0} {1:w} attempts left before login is locked for 5 minutes.', '{0} Le quedan {1} intentos antes de que el inicio de sesión se bloquee por 5 minutos.'],
  ['For your security, login is locked. Please try again in {0} minutes.', 'Por su seguridad, el inicio de sesión está bloqueado. Inténtelo de nuevo en {0} minutos.'],
];

const escapeRegex = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const COMPILED = ES_TEMPLATES.map(([en, es]) => {
  // {0:w} matches one word, {0} matches anything
  const pattern = escapeRegex(en)
    .replace(/\\\{(\d+):w\\\}/g, '(\\S+)')
    .replace(/\\\{(\d+)\\\}/g, '(.+?)');
  return { regex: new RegExp('^' + pattern + '$'), es };
});

/**
 * Returns the Spanish text for a message built from a known template, or null.
 * `translateValue` is used to translate the values inside the message.
 */
export function translateDynamic(text: string, lang: string, translateValue: (v: string) => string): string | null {
  if (lang !== 'es' || !text) return null;
  for (const { regex, es } of COMPILED) {
    const m = regex.exec(text);
    if (m) {
      return es.replace(/\{(\d+)\}/g, (_, i) => translateValue(m[Number(i) + 1] ?? ''));
    }
  }
  return null;
}
